module.exports = __webpack_public_path__ + "static/ItemDetails-a20fe4aa0cfc268b0057adb75d5a5b44.png";